import React from "react";

import pill from "./../../../UI/general/pill.svg";
import collapse from "./../../../UI/general/collapse.svg";
import delet from "./../../../UI/quotation/delete.svg";

interface Props {
  isQuotationModalOpened: boolean;
  handleOpenQuoationModal: any;
  quotationProperties: any;
  colors: any;
  handleSendQuotation: any;
  handleRemovePropertyInQuotation: any;
  isSendQuotation: any;
  statusQuotation: any;
}

interface State {
  selectedAptosCollapsed: boolean;
  nameQuotation: any;
  phoneQuotation: any;
  emailQuotation: any;
  messageError: any;
}

class QuotationModalMobile extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      selectedAptosCollapsed: true,
      nameQuotation: "",
      phoneQuotation: "",
      emailQuotation: "",
      messageError: "",
    };
  }

  handleSendQuotation = () => {
    if (
      this.state.nameQuotation !== "" &&
      this.state.phoneQuotation !== "" &&
      this.state.emailQuotation !== ""
    ) {
      this.props.handleSendQuotation({
        name: this.state.nameQuotation,
        phone: this.state.phoneQuotation,
        destino: this.state.emailQuotation,
      });
      this.setState({
        messageError: "",
      });
    } else {
      this.setState({
        messageError: "Llena todos los campos para continuar.",
      });
    }
  };

  render(): React.ReactNode {
    return (
      <div
        className={
          this.props.isQuotationModalOpened
            ? "quotation-modal-container-opened-mobile"
            : "quotation-modal-container-closed-mobile"
        }
      >
        <div
          className="close-quotation-modal-mobile"
          onClick={() => {
            this.props.handleOpenQuoationModal();
          }}
        >
          <img src={pill} alt="" />
        </div>
        <div className="quotation-info-container-mobile">
          <div className="quotation-info-name-mobile">Cotización</div>
          {!this.props.isSendQuotation ? (
            <>
              <div className="quotation-info-text-mobile">
                Llena los campos y recibirás en tu correo más información de los
                inmuebles.
              </div>
              <div className="quotation-info-inputs-container-mobile">
                <input
                  type={"text"}
                  placeholder="Nombres"
                  onChange={(e: any) =>
                    this.setState({ nameQuotation: e.target.value })
                  }
                ></input>
                <input
                  type={"number"}
                  placeholder="Teléfono"
                  onChange={(e: any) =>
                    this.setState({ phoneQuotation: e.target.value })
                  }
                ></input>
                <input
                  type={"email"}
                  placeholder="Correo electrónico"
                  onChange={(e: any) =>
                    this.setState({ emailQuotation: e.target.value })
                  }
                ></input>
              </div>
              <div className="selected-properties-container-mobile">
                <div
                  className="selected-properties-header"
                  onClick={() => {
                    this.setState({
                      selectedAptosCollapsed:
                        !this.state.selectedAptosCollapsed,
                    });
                  }}
                >
                  <div>{"inmuebles seleccionados".toUpperCase()}</div>
                  <img src={collapse} alt="" />
                </div>
                {this.state.selectedAptosCollapsed ? null : (
                  <div className="quotation-selected-individual-container-mobile">
                    {this.props.quotationProperties?.map((property: any) => (
                      <div className="quotation-selected-individual-mobile">
                        <div className="quotation-property-mobile">
                          <div>{property.property}</div>
                          {
                            <div
                              style={{ color: "#757575", fontSize: ".7rem" }}
                            >
                              {property.values.filter(
                                (e: any) =>
                                  e.hierarchicalLevel === "Jerarquico #3"
                              ).length > 0
                                ? property.values.filter(
                                    (e: any) =>
                                      e.hierarchicalLevel === "Jerarquico #3"
                                  )[0].value + "/"
                                : null}
                              {property.values.filter(
                                (e: any) =>
                                  e.hierarchicalLevel === "Jerarquico #2"
                              ).length > 0
                                ? property.values.filter(
                                    (e: any) =>
                                      e.hierarchicalLevel === "Jerarquico #2"
                                  )[0].value + "/"
                                : null}
                              {property.values.filter(
                                (e: any) =>
                                  e.hierarchicalLevel === "Jerarquico #1"
                              ).length > 0
                                ? property.values.filter(
                                    (e: any) =>
                                      e.hierarchicalLevel === "Jerarquico #1"
                                  )[0].value
                                : null}
                            </div>
                          }
                        </div>
                        <div
                          className="quotation-delete-mobile"
                          onClick={() =>
                            this.props.handleRemovePropertyInQuotation(property)
                          }
                        >
                          <img src={delet} alt="" />
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div
                className="quotation-send-btn-mobile"
                onClick={() => this.handleSendQuotation()}
              >
                Enviar
              </div>
              {this.state.messageError.length > 0 ? (
                <div
                  className="quotation-txt-error-mobile"
                  style={{
                    color: this.props.colors.main_text,
                  }}
                >
                  {this.state.messageError}
                </div>
              ) : null}
              <div className="quotation-legal-text-mobile">
                Al presionar <b>ENVIAR</b> estoy aceptando todos los térmios y
                condiciones tratados en nuestra{" "}
                <a href="/">Declaración de Privacidad</a>
              </div>{" "}
            </>
          ) : (
            <div>
              <div className="quotation-info-text-mobile">
                Hemos recibido tu solicitud
              </div>
              <div className="quotation-info-text-mobile">
                En breve recibirás un correo con la información de los inmuebles
                que te han interesado.
              </div>
              <div
                className="quotation-send-btn-mobile"
                style={{
                  backgroundColor: this.props.colors.main_buttons,
                  color: this.props.colors.secondary_text,
                }}
                onClick={() => {
                  this.props.handleOpenQuoationModal();
                }}
              >
                Regresar
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default QuotationModalMobile;
